import React from 'react';
import { render } from 'react-dom';
import { Input, Checkbox, Button, Modal } from 'antd';
import Background from '../../images/Background.png'
import Logo from '../../images/logos/trackerapps.png'
import RegisterModal from './registerModal'
import { translate } from 'react-i18next';
import googleplay from '../../images/googleplay.png';
import appstore from '../../images/appstore.png';
import { compose } from 'redux';

class LoginScreen extends React.Component {

  constructor() {
    super();
    this.state = {
      email: null,
      password: null,
      checked: false,
      login: true,
      modalShowing: false
    }
  }

  login = () => {
    this.props.login(this.state.email, this.state.password, this.state.checked);
  }

  reset = () => {
    this.props.resetPass(this.state.email);
  }


  loginForm = () => {
    const { t, lng } = this.props
    const { modalShowing } = this.state 

    return (
      <div style={styles.inner}>
        <label style={styles.label}>{t('Email Address')}</label>
        <input style={styles.input} type="text" onChange={(e) => this.setState({email: e.target.value})} />
        <label style={styles.label}>{t('Password')}</label>
        <input style={styles.input} type="password" onChange={(e) => this.setState({password: e.target.value})} />
        {this.props.errorMsg && <p style={styles.invalid}>{this.props.errorMsg}</p>}
        <Checkbox style={styles.label} onChange={(e) => this.setState({checked: e.target.checked})}>{t('Remember me')}</Checkbox>
        <Button disabled={this.state.login && this.state.password ? false : true } style={styles.button} onClick={this.login} type="primary">{t('Login')}</Button>
        <p onClick={() => this.setState({login: false})} style={styles.forgot}>{t('Forgot your password?')}</p>
        <div onClick={() => this.setState({modalShowing: true})} style={styles.registerBtn}>
          {t('No account yet?')} <br />
          {t('Download the app and register')}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
          <a href="https://itunes.apple.com/my/app/skill-tracker/id1390479942?mt=8">
            <img
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '165px'
              }}
              src={appstore}
            />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.skilltracker">
            <img
              style={{
                width: '100%',
                height: '100%',
                maxWidth: '160px',
                height: '98%'
              }}
              src={googleplay}
            />
          </a>
        </div>
        {lng == 'EN'
          ? <p onClick={() => this.props.changeLanguage('FR')} style={styles.lang}>Français</p>
          : <p onClick={() => this.props.changeLanguage('EN')} style={styles.lang}>English</p>
        }
        <RegisterModal
          visible={modalShowing}
          closeModal={() => this.setState({modalShowing: false})}
          t={t}
        />
      </div>
    )
  }

  resetPassForm = () => {
    const { t } = this.props
    return (
      <div style={styles.inner}>
        <label style={styles.label}>{t('Forgot your password?')}</label>
        <input style={styles.input} type="email" onChange={(e) => this.setState({email: e.target.value})} />
        {this.props.resetSuccess && <p style={styles.msg}>{t('A reset link has been sent to your email address')}</p>}
        <Button disabled={this.state.email ? false : true } style={styles.button} onClick={this.reset} type="primary">{t('Reset')}</Button>
        <p onClick={() => this.setState({login: true})}  style={styles.forgot}>{t('Login instead?')}</p>
      </div>
    )
  }

  render() {

    const { t } = this.props;
    return (
      <div style={styles.background}>
        <div style={styles.container}>
          <img src={Logo} alt="Skilltracker logo" style={styles.logo} />
          {this.state.login ? this.loginForm() : this.resetPassForm()}
        </div>
      </div>
    )
  }
}
const enhancer = compose(
  translate('lang'),
)
export default enhancer(LoginScreen);

const styles = {

  background: {
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: 'auto',
    width: '100vw',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh'
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '380px',
    width: '80%',
    padding: '20px'
  },

  logo: {
    width: '163px',
    marginBottom: '40px'
  },

  label: {
    color: '#696969',
    fontSize: '14px',
    marginRight: 'auto',
    marginBottom: '5px',
    fontWeight: 600,
  },

  input: {
    width: '100%',
    marginBottom: '10px',
    height: '32px',
    border: '0.8px solid #D9D9D9',
    borderRadius: '5px',
    paddingLeft: '10px',
    backgroundColor: 'white'
  },

  button: {
    marginTop: '20px',
    marginBottom: '20px',
    width: '105px'
  },

  forgot: {
    color: '#696969',
    fontSize: '14px',
    marginBottom: '5px',
    fontWeight: 600,
    cursor: 'pointer'
  },

  lang: {
    color: '#696969',
    fontSize: '14px',
    marginBottom: '5px',
    marginTop: 20,
    textDecoration: 'underline',
    fontWeight: 600,
    cursor: 'pointer'
  },

  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },

  msg: {
    fontSize: '14px',
    marginRight: 'auto',
    color: '#319D02',
    marginTop: '-10px'
  },
  invalid: {
    fontSize: '14px',
    marginRight: 'auto',
    color: 'red',
    marginTop: '-10px'
  },
  registerBtn: {
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#1890ff',
    color: 'white',
    width: '90%',
    borderRadius: 10,
    padding: 10,
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 20
  }

}



// WEBPACK FOOTER //
// ./src/components/LoginScreen/index.jsx